// ProductsPage.js
import React, { useEffect, useState } from 'react';
import Product from '../components/Product';
import ProductInfo from '../components/ProductInfo';

const ProductsPage = () => {
  const [productID, setProductID] = useState(1);
  const [products, setProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredProducts, setFilteredProducts] = useState([]);

  useEffect(() => {
    fetch('https://fakestoreapi.com/products')
      .then(res=>res.json())
      .then(data => setProducts(data));
  }, []);

  // Filter products based on search query
  useEffect(() => {
    const filtered = products.filter(product =>
      product.title.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredProducts(filtered);
  }, [searchQuery, products]);

  // Handle search input change
  const handleSearchInputChange = event => {
    setSearchQuery(event.target.value);
  };
    
  const openProduct = (id) => {
    setProductID(id);
  }

    return (
      <div>
        <input
          type="text"
          placeholder="Search by product name"
          value={searchQuery}
          onChange={handleSearchInputChange}
        />
        <div id="main">
          
            <div id="productList">
                {
                    filteredProducts.map((product, index) => {
                        return (
                            <Product key={index} productID={product} onClick={openProduct}/>
                        )
                    })
                }
            </div>
            <ProductInfo productID={productID}/>
        </div>
      </div>
    )
}

export default ProductsPage;
